module.exports = __webpack_public_path__ + "static/media/flag10.5b1ecb1a.svg";